import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import RixinHero from './components/RixinHero';
import RixinTeam from './components/RixinTeam';
import RixinFactories from './components/RixinFactories';
import RixinCertifications from './components/RixinCertifications';
import RixinRD from './components/RixinRD';
import RixinService from './components/RixinService';
import RixinProducts from './components/RixinProducts';
import RixinClients from './components/RixinClients';
import RixinCTA from './components/RixinCTA';

export default function RixinPage() {
  return (
    <main className="min-h-screen bg-background-50 overflow-x-hidden">
      <Navbar />
      <RixinHero />
      <RixinTeam />
      <RixinFactories />
      <RixinCertifications />
      <RixinRD />
      <RixinService />
      <RixinProducts />
      <RixinClients />
      <RixinCTA />
      <Footer />

      {/* WhatsApp Floating Button */}
      <a
        href="https://wa.me/584129080594?text=Hola%2C%20quisiera%20solicitar%20informaci%C3%B3n%20sobre%20sus%20productos"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 flex items-center justify-center rounded-full bg-green-500 hover:bg-green-600 transition-all duration-300 shadow-lg hover:scale-110 cursor-pointer"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-fill text-white text-2xl" />
      </a>
    </main>
  );
}